import { render, staticRenderFns } from "./BlogPostRestrictedVisibility.vue?vue&type=template&id=4a52e3f4"
import script from "./BlogPostRestrictedVisibility.vue?vue&type=script&lang=js"
export * from "./BlogPostRestrictedVisibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports